export const getToggleButtonProps = (value, isLeftButton) => {
  const commonClasses =
    '!border-t-0 !border-b-0 !hover:bg-gray-200 !dark:hover:bg-gray-600';
  const borderClass = isLeftButton
    ? '!border-l-0 !border-r'
    : '!border-r-0 !border-l';
  const borderColor = '!border-cool-gray';

  return {
    value: value,
    classes: {
      root: `${commonClasses} ${borderClass} ${borderColor}`,
    },
    sx: {
      '&:not(.Mui-selected)': {
        color: '#6b7280',
      },
    },
  };
};
